module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_add-to-unscopables.js
// module id = ./node_modules/core-js/library/modules/_add-to-unscopables.js
// module chunks = 1